import type { SettlementMethod } from '@/types/billing';

export function formatCurrency(amount: number): string {
  return amount.toLocaleString();
}

export function getPaymentMethodLabel(
  code: SettlementMethod | string,
  t: (key: string, options?: Record<string, unknown>) => string
): string {
  return t(`billing.payment.paymentMethodMap.${code}`, { defaultValue: code });
}

// 백엔드가 "YYYY년 MM월 이용 요금" 형식으로 내려주는 itemName/chargeName을
// 현재 언어에 맞춰 billing.payment.monthlyPayment 포맷으로 재출력.
// 형식이 매칭되지 않으면 원본 그대로 반환.
const MONTHLY_PAYMENT_RE = /(\d{4})\s*년\s*(\d{1,2})\s*월/;

export function formatPaymentItemName(
  rawName: string,
  t: (key: string, options?: Record<string, unknown>) => string
): string {
  const match = rawName.match(MONTHLY_PAYMENT_RE);
  if (!match) return rawName;
  const [, year, monthRaw] = match;
  const month = monthRaw.padStart(2, '0');
  return t('billing.payment.monthlyPayment', { year, month });
}
